"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Gallery = _interopRequireDefault(require("../Gallery"));

var _Image = _interopRequireDefault(require("../Gallery/Image"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    momentBody: {
      background: theme.palette.grey[200]
    },
    sideBar: {
      width: "40%",
      maxWidth: 500
    },
    button: {
      marginTop: 10,
      fontSize: "75%",
      zIndex: 1
    },
    galleryImage: {
      maxWidth: 300
    }
  };
});
/**
 * Moment to display entities that are named after the `Story`'s subject'.
 */

function NamedAfterMoment(props) {
  var color = props.color,
      data = props.data;
  var classes = useStyles();
  return _react.default.createElement(_Gallery.default, _extends({
    bodyClassName: classes.momentBody
  }, props), data.map(function (_ref) {
    var description = _ref.description,
        image = _ref.image,
        fallback = _ref.fallback,
        label = _ref.label,
        website = _ref.website;
    return _react.default.createElement(_Image.default, {
      color: color,
      label: label,
      noImage: image ? false : true,
      src: image || fallback,
      className: classes.galleryImage,
      content: _react.default.createElement("div", {
        className: "named-after-item-content"
      }, description && _react.default.createElement("div", {
        className: "named-after-item-content__description"
      }, description), website && _react.default.createElement(_core.Button, {
        className: classes.button,
        style: {
          background: color.background,
          color: color.text
        },
        target: "_blank",
        href: website,
        variant: "contained"
      }, "Learn More"))
    });
  }));
}

NamedAfterMoment.propTypes = {
  /** Determines the background and text color of the `Moment` header. */
  color: _propTypes.default.shape({
    background: _propTypes.default.string,
    text: _propTypes.default.string
  }),

  /** Information to build the `GalleryImage`s */
  data: _propTypes.default.arrayOf(_propTypes.default.object).isRequired,

  /** Determines the `SideBarSection` `Icon` of the `Moment`. */
  icon: _propTypes.default.element,

  /** Used to serialize the order of the `Moment`s in a `Story` */
  index: _propTypes.default.number,

  /** Determines the `SideBarSection` text of the `Moment`. */
  label: _propTypes.default.string,

  /** Paragraph text underneath the title in `Moment` header */
  subtitle: _propTypes.default.string,

  /** Main heading element of the `Moment` */
  title: _propTypes.default.node,

  /** The type of `Moment` */
  type: _propTypes.default.string
};
NamedAfterMoment.defaultProps = {
  type: "named_after"
};
var _default = NamedAfterMoment;
exports.default = _default;